import React from "react";

import Background from "../../../assets/dinner/dinner-bg-02.png";
import Image from "../../../assets/dinner/dinner-choice-a.png";

import GamePageLayout from "../GamePageLayout";

const DinnerPage3 = ({ setCurrentPage }) => {
  return (
    <GamePageLayout
      bg={Background}
      img={Image}
      onClickNext={() => setCurrentPage("cleaning-1")}
    >
      집에서 있는 재료로 해먹으면
      <br />
      포장 쓰레기가 안 나오지!
      <br />
      불금을 떡볶이와 맥주와 넷플릭스로
      <br />
      보내니 꿀맛이로구나....
    </GamePageLayout>
  );
};

export default DinnerPage3;
